import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { slugify } from '../../utils/articles';
import './articles.css';

const codeStyle = {
  margin: '18px 0',
  padding: '16px 18px',
  borderRadius: 10,
  background: 'var(--art-pre-bg)',
  border: '1px solid var(--art-pre-border)',
  fontSize: '13px',
  lineHeight: 1.6,
};

const textOf = (children) => React.Children.toArray(children)
  .map(c => (typeof c === 'string' ? c : c?.props?.children ? textOf(c.props.children) : ''))
  .join('');

const components = {
  // Âncoras dos ## para o sumário lateral
  h2: ({ children }) => <h2 id={slugify(textOf(children))}>{children}</h2>,
  code({ inline, className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || '');
    if (inline) return <code className={className} {...props}>{children}</code>;
    return (
      <SyntaxHighlighter style={vscDarkPlus} language={match ? match[1] : 'text'} PreTag="div" customStyle={codeStyle}>
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    );
  },
  a: ({ href, children }) => <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>,
  table: ({ children }) => <div className="art-body__table"><table>{children}</table></div>,
};

/** Corpo do artigo em Markdown, com a tipografia de leitura (também usado na prévia do editor). */
export function ArticleBody({ markdown, className = '', bodyRef }) {
  return (
    <div className={`art-body ${className}`} ref={bodyRef}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{markdown || ''}</ReactMarkdown>
    </div>
  );
}
